import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import { NumbersInfoStyled } from './NumbersInfoStyled';
import classnames from 'classnames';
import styles from './numbersInfo.less?modules';
import { fmtThousand, transNum } from '@/utils/comUtil';
// import { fmtPercentUpDown, fmtThousand, transNum } from '@/utils/comUtil';
import dormantMembers from '@/assets/img/bizgrowth/dormantMembers.png';

const DormantMembers = (props) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const {
    title = '会员数',
    vipCount = 0,
    count = 0,
    day = 0,
    // dayRate = 0.89,
    week = 0,
    // weekRate = 0.69,
    month = 0,
    // monthRate = 0.78,
    cycleList,
    classname,
    // hidden,
  } = props;

  return (
    <NumbersInfoStyled
      theme={themeContext}
      className={styles.box}
      brand={brandContext}
    >
      <div className={styles.box_r1}>
        <div className={styles.box_r1_c1}>
          <img src={dormantMembers} alt="" />
          <span className={'label_t'}>{title || ''}</span>
        </div>
        <div className={styles.box_r1_c2 + ' ' + classname}></div>
      </div>
      <div className={styles.box_r2}>
        <div className={styles.box_r2_c1}>
          <span className={'label_p'}>30{cycleList[0]}</span>
          <span className={'label_p'}>90{cycleList[0]}</span>
          <span className={'label_p'}>180{cycleList[0]}</span>
        </div>
        <div className={styles.box_r2_c2}>
          <p>
            <span className={'value_t'}>
              {/* <span className={classnames(styles.value_t,'value_t')}> */}
              {fmtThousand(count)}
            </span>
            <span className={'vip_count'}>
              其中VIP数量：{fmtThousand(vipCount) || '--'}
            </span>
          </p>
          <span className={classnames('no_date')}>{transNum(day) || 0}</span>
          <span className={classnames('no_date')}>{transNum(week) || 0}</span>
          <span className={classnames('no_date')}>{transNum(month) || 0}</span>
        </div>

        {/* <div className={styles.box_r2_c2}>

          <span className={classnames('no_number')}>

            {!hidden&&(
              <span
              className={classnames(
                weekRate > 0 ? 'up_number' : 'down_number',
              )}
            >
              {fmtPercentUpDown(weekRate) || '--'}
            </span>
            )}
          </span>
        </div> */}
        {/*
        <div className={styles.box_r2_c3}>

          <span className={classnames('no_number')}>
            {!hidden&&(
              <span
              className={classnames(
                dayRate > 0 ? 'up_number' : 'down_number',
              )}
            >
              {fmtPercentUpDown(dayRate) || '--'}
            </span>
            )}
          </span>
          <span className={classnames('no_number')}>
            {!hidden&&(
              <span
              className={classnames(
                monthRate > 0 ? 'up_number' : 'down_number',
              )}
            >
              {fmtPercentUpDown(monthRate) || '--'}
            </span>
            )}
          </span>
        </div> */}
      </div>
      {/* </div> */}
    </NumbersInfoStyled>
  );
};
export default DormantMembers;
